import { getLeFEOrigin } from '@utils/util';

export const MtdbTrialManagerLeFE = () => (
    <iframe className="admin-iframe" title="问卷管理" src={`${getLeFEOrigin()}/#/app/mtdb/mtdb_trial`} />
);
